import { render, staticRenderFns } from "./armor.vue?vue&type=template&id=4392543e&"
import script from "./armor.vue?vue&type=script&lang=js&"
export * from "./armor.vue?vue&type=script&lang=js&"
import style0 from "./armor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports